import { render, staticRenderFns } from "./footer-recall.vue?vue&type=template&id=3bf270d7&scoped=true"
import script from "./footer-recall.vue?vue&type=script&lang=js"
export * from "./footer-recall.vue?vue&type=script&lang=js"
import style0 from "./footer-recall.vue?vue&type=style&index=0&id=3bf270d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf270d7",
  null
  
)

export default component.exports